module.exports = __webpack_public_path__ + "img/fin_07_孤独种植.41410695.jpg";